<ambita-cadastre-report-buildings>
  <div class="ambita-cadastre-report__section ambita-cadastre-report__buildings" id="ambita-cadastre-report__buildings"
       if="{ data }">
    <h4 class="ambita-cadastre-report__section-title ambita-report-h4">{ i18n.propertyLookup.titleBuildings }</h4>
    <div class="ambita-cadastre-report__sub-section--collapsible
              { ambita-cadastre-report__sub-section--collapsed: data.buildings.length != 1 }"
         each="{ building, i in data.buildings }">
      <header class="ambita-cadastre-report__sub-section-header" onclick="{ collapse }">
        <i class="ambita-cadastre-report__sub-section-arrow"></i>
        <h5 class="ambita-cadastre-report__sub-section-title ambita-report-h5">
          { i18n.propertyLookup.building } { i + 1 }
          { i18n.propertyLookup.buildingOf }
          { data.buildings.length }:
          { building.typeOfBuilding.text }
          <span class="ambita-cadastre-report__building-source" if="{ building.originType }">
            ({ i18n.propertyLookup.buildingSource }: { building.originType.text })
          </span>
        </h5>
      </header>
      <div class="ambita-cadastre-report__sub-section-content">
        <div class="ambita-cadastre-report__group">
          <h6 class="ambita-report-h6">{ i18n.propertyLookup.buildingTitleUnits }:</h6>
          <table class="ambita-cadastre-report__list">
            <thead class="ambita-cadastre-report__header">
            <tr class="ambita-cadastre-report__row">
              <th>{ i18n.propertyLookup.unitAddress }</th>
              <th>{ i18n.propertyLookup.unitNo }</th>
              <th>{ i18n.propertyLookup.unitType }</th>
              <th class="ambita-text-right">{ i18n.propertyLookup.unitBRA }</th>
              <th>{ i18n.propertyLookup.unitKitchen}</th>
              <th class="ambita-text-right">{ i18n.propertyLookup.unitNoOfRooms }</th>
              <th class="ambita-text-right">{ i18n.propertyLookup.unitNumberOfBathRooms }</th>
              <th class="ambita-text-right">{ i18n.propertyLookup.unitNumberOfWCs }</th>
            </tr>
            </thead>
            <tbody>
            <tr class="ambita-cadastre-report__row" each="{ unit in building.units }">
              <td>{ unit.address.shortStreetAddress || unit.address.shortCadastreAddress }</td>
              <td>{ unit.unitNumber }</td>
              <td>{ unit.unitType.text }</td>
              <td class="ambita-text-right">{ formatNumber(unit.usableArea, 1) }</td>
              <td>{ unit.kitchenAccessCode.text }</td>
              <td class="ambita-text-right">{ unit.numberOfRooms }</td>
              <td class="ambita-text-right">{ unit.numberOfBathRooms }</td>
              <td class="ambita-text-right">{ unit.numberOfWCs }</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="ambita-cadastre-report__group">
          <h6 class="ambita-report-h6">{ i18n.propertyLookup.buildingTitleInfo }:</h6>
          <div class="ambita-cadastre-report-clearfix">
            <ul class="ambita-cadastre-report__document-output ambita-cadastre-report__col-half ambita-report-ul">
              <li>
                <span class="ambita-cadastre-report__document-output-title">
                  { i18n.propertyLookup.buildingIndustryGroup }
                </span>
                <span class="ambita-cadastre-report__document-output-value">
                  { building.industryGroup && building.industryGroup.text || i18n.propertyLookup.unprovided }
                </span>
              </li>
              <li>
                <span class="ambita-cadastre-report__document-output-title">
                  { i18n.propertyLookup.buildingStatus }
                </span>
                <span class="ambita-cadastre-report__document-output-value">{ building.buildingStatus.text }</span>
              </li>
              <li>
                <span class="ambita-cadastre-report__document-output-title">
                  { i18n.propertyLookup.buildingEnergySourceType }
                </span>
                <span class="ambita-cadastre-report__document-output-value">
                  { arrayTextWriter(building.energySourceType) }
                </span>
              </li>
              <li>
                <span class="ambita-cadastre-report__document-output-title">
                  { i18n.propertyLookup.buildingHeatingType }
                </span>
                <span class="ambita-cadastre-report__document-output-value">
                  { arrayTextWriter(building.heatingType) }
                </span>
              </li>
              <li>
                <span class="ambita-cadastre-report__document-output-title">
                  { i18n.propertyLookup.buildingDischargeType }
                </span>
                <span class="ambita-cadastre-report__document-output-value">{ building.dischargeType.text }</span>
              </li>
              <li>
                <span class="ambita-cadastre-report__document-output-title">
                  { i18n.propertyLookup.buildingWaterSupplyType }
                </span>
                <span class="ambita-cadastre-report__document-output-value">{ building.waterSupplyType.text }</span>
              </li>
              <li>
                <span class="ambita-cadastre-report__document-output-title">
                  { i18n.propertyLookup.buildingNumber }
                </span>
                <span class="ambita-cadastre-report__document-output-value">{ building.buildingNumber }</span>
              </li>
            </ul>

            <ul class="ambita-cadastre-report__document-output ambita-cadastre-report__col-small ambita-report-ul">
              <li>
                <span class="ambita-cadastre-report__document-output-title">
                  { i18n.propertyLookup.buildingBuiltUpArea }
                </span>
                <span class="ambita-cadastre-report__document-output-value">
                  { formatNumber(building.builtUpArea, 1) }
                </span>
              </li>
              <li>
                <span class="ambita-cadastre-report__document-output-title">
                  { i18n.propertyLookup.buildingPrimarySpace }
                </span>
                <span class="ambita-cadastre-report__document-output-value">
                  { formatNumber(building.totalAreaOfPrimarySpace, 1) }
                </span>
              </li>
              <li>
                <span class="ambita-cadastre-report__document-output-title">
                  { i18n.propertyLookup.buildingSecondarySpace }
                </span>
                <span class="ambita-cadastre-report__document-output-value">
                  { formatNumber(building.areaOfSecondarySpace, 1) }
                </span>
              </li>
              <li>
                <span class="ambita-cadastre-report__document-output-title">
                  { i18n.propertyLookup.buildingTotalFloorSpace }
                </span>
                <span class="ambita-cadastre-report__document-output-value">
                  { formatNumber(building.totalFloorSpace, 1) }
                </span>
              </li>
              <li>
                <span class="ambita-cadastre-report__document-output-title">
                  { i18n.propertyLookup.buildingHasElevator }
                </span>
                <span class="ambita-cadastre-report__document-output-value">
                  { booleanWriter(building.hasElevator) }
                </span>
              </li>
            </ul>

            <ul class="ambita-cadastre-report__document-output ambita-cadastre-report__col-medium ambita-report-ul">
              <li>
                <span class="ambita-cadastre-report__document-output-title">
                  { i18n.propertyLookup.buildingApprovedDate }
                </span>
                <span class="ambita-cadastre-report__document-output-value">{ building.buildingPermit }</span>
              </li>
              <li>
                <span class="ambita-cadastre-report__document-output-title">
                  { i18n.propertyLookup.buildingStartedDate }
                </span>
                <span class="ambita-cadastre-report__document-output-value">{ building.approvedStartPermit }</span>
              </li>
              <li>
                <span class="ambita-cadastre-report__document-output-title">
                  { i18n.propertyLookup.buildingCertificateOfCompletion }
                </span>
                <span class="ambita-cadastre-report__document-output-value">{ building.certificateOfCompletion }</span>
              </li>
              <li>
                <span class="ambita-cadastre-report__document-output-title">
                  { i18n.propertyLookup.buildingProvisionalPermission }
                </span>
                <span class="ambita-cadastre-report__document-output-value">
                  { building.provisionalPermissionToUse }
                </span>
              </li>
              <li>
                <span class="ambita-cadastre-report__document-output-title">
                  { i18n.propertyLookup.buildingApprovedUsedFrom }
                </span>
                <span class="ambita-cadastre-report__document-output-value">{ building.approvedUsedFrom }</span>
              </li>
              <li>
                <span class="ambita-cadastre-report__document-output-title">
                  { i18n.propertyLookup.buildingNumberOfUnits }
                </span>
                <span class="ambita-cadastre-report__document-output-value">
                  { formatNumber(building.numberOfUnits) }
                </span>
              </li>
              <li>
                <span class="ambita-cadastre-report__document-output-title">
                  { i18n.propertyLookup.buildingNumberOfFloors }
                </span>
                <span class="ambita-cadastre-report__document-output-value">
                  { formatNumber(building.numberOfFloors) }
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div class="ambita-cadastre-report__group">
          <h6 class="ambita-report-h6">{ i18n.propertyLookup.buildingTitleFloors }:</h6>
          <table class="ambita-cadastre-report__list" if="{ building.floors }">
            <thead class="ambita-cadastre-report__header">
            <tr class="ambita-cadastre-report__row">
              <th>{ i18n.propertyLookup.floorNo }</th>
              <th class="ambita-cadastre-report__row--padded-right ambita-text-right">
                { i18n.propertyLookup.floorNoOfUnits }
              </th>
              <th class="ambita-cadastre-report__row--border-left">{ i18n.propertyLookup.floorBRA }:</th>
              <th class="ambita-text-right">{ i18n.propertyLookup.floorUnit }</th>
              <th class="ambita-text-right">{ i18n.propertyLookup.floorOther }</th>
              <th class="ambita-cadastre-report__row--padded-right ambita-text-right">
                { i18n.propertyLookup.floorTotal }
              </th>
              <th class="ambita-cadastre-report__row--border-left">{ i18n.propertyLookup.floorBTA }:</th>
              <th class="ambita-text-right">{ i18n.propertyLookup.floorUnit }</th>
              <th class="ambita-text-right">{ i18n.propertyLookup.floorOther }</th>
              <th class="ambita-text-right">{ i18n.propertyLookup.floorTotal }</th>
            </tr>
            </thead>
            <tbody>
            <tr class="ambita-cadastre-report__row { red: floor.unitFloor }" each="{ floor in building.floors }">
              <td>{ floor.floorIdent }</td>
              <td class="ambita-cadastre-report__row--padded-right ambita-text-right">
                { formatNumber(floor.numberOfDwellingUnits) }
              </td>
              <td class="ambita-cadastre-report__row--border-left-empty">&nbsp;</td>
              <td class="ambita-text-right">{ formatNumber(floor.totalAreaOfPrimarySpace, 1) }</td>
              <td class="ambita-text-right">{ formatNumber(floor.totalAlternateArea, 1) }</td>
              <td class="ambita-cadastre-report__row--padded-right ambita-text-right">
                { formatNumber(floor.totalUsableArea, 1) }
              </td>
              <td class="ambita-cadastre-report__row--border-left-empty">&nbsp;</td>
              <td class="ambita-text-right">{ formatNumber(floor.totalAreaHousing, 1) }</td>
              <td class="ambita-text-right">{ formatNumber(floor.totalFloorSpace, 1) }</td>
              <td class="ambita-text-right">{ formatNumber(floor.totalArea, 1) }</td>
            </tr>
            </tbody>
          </table>
          <p if="{ !building.floors }">
            { i18n.propertyLookup.floorInfo }
          </p>
        </div>

        <div class="ambita-cadastre-report__group">
          <h6 class="ambita-report-h6">{ i18n.propertyLookup.buildingTitleHeritages }:</h6>
          <div class="ambita-cadastre-report__sub-group" if="{ building.singleHeritages }">
            <h6 class="ambita-report-h6">{ i18n.propertyLookup.heritagesTitle }:</h6>
            <ambita-cadastre-report-single-heritages heritages="{ building.singleHeritages }"/>
          </div>
          <div class="ambita-cadastre-report__sub-group" if="{ building.culturalHeritages }">
            <h6 class="ambita-report-h6">{ i18n.propertyLookup.culturalHeritagesSefrak }:</h6>
            <ambita-cadastre-report-cultural-heritages heritages="{ building.culturalHeritages }"/>
          </div>
          <p if="{ !building.culturalHeritages && !building.singleHeritages }">{ i18n.propertyLookup.heritagesInfo }</p>
        </div>

        <div class="ambita-cadastre-report__group">
          <h6 class="ambita-report-h6">{ i18n.propertyLookup.buildingTitleCoordinates }:</h6>
          <table class="ambita-cadastre-report__list">
            <thead class="ambita-cadastre-report__header">
            <tr class="ambita-cadastre-report__row">
              <th>{ i18n.propertyLookup.coordSystem }</th>
              <th>{ i18n.propertyLookup.coordX }</th>
              <th>{ i18n.propertyLookup.coordY }</th>
            </tr>
            </thead>
            <tbody>
            <tr class="ambita-cadastre-report__row">
              <td>23</td>
              <td>{ building.coordinates[1] }</td>
              <td>{ building.coordinates[0] }</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <p if="{ showBuildingInfo }">{ i18n.propertyLookup.buildingInfo }</p>
  </div>

  <script>
    import './subsections/singleHeritages.tag';
    import './subsections/culturalHeritages.tag';
    import { init } from './sectionController';

    init(this);
  </script>
</ambita-cadastre-report-buildings>
